import { Controller } from "@hotwired/stimulus"


export default class extends Controller {

  static targets = ['chunk', 'bullet'];
  static values = {
    currentChunk: Number,
    lastChunk: {
      type: Number,
      default: 0
    },
    lastChunkSaveUrl: String,
  }

  beforeMorphAttribute(element) {
    element.addEventListener(
      'turbo:before-morph-attribute', (event) => {
        if (event.detail.attributeName === 'class') {
          event.preventDefault();
        }
      }
    )
  }

  chunkTargetConnected(element) {
    this.beforeMorphAttribute(element);
  }

  currentChunkValueChanged() {
    this.showCurrentChunk();
    this.saveCurrentChunk();
  }

  saveCurrentChunk() {
    if (this.lastChunkSaveUrlValue) {
      // Get the CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

      fetch(this.lastChunkSaveUrlValue, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `last_chunk=${this.lastChunkValue}&current_chunk=${this.currentChunkValue}`
      });
    }
  }

  setCurrentChunk({ params: { chunkIndex } }) {
    if (chunkIndex <= this.lastChunkValue + 1) {
      this.currentChunkValue = chunkIndex;
    }
  }

  next() {
    this.currentChunkValue += 1;
  }

  lastChunkValueChanged() {
    this.bulletTargets.forEach((bullet, index) => {
      if (index <= this.lastChunkValue + 1) {
        bullet.classList.remove('disabled');
      } else {
        bullet.classList.add('disabled');
      }
    });

    this.bulletTargets.forEach((bullet, index) => {
      if (index < this.lastChunkValue) {
        bullet.classList.add('completed');
      }
    });
    if (this.lastChunkValue === this.chunkTargets.length - 1 && this.chunkTargets.length) {
      this.bulletTargets[this.lastChunkValue]?.classList.add('completed');
    }
  }

  bulletTargetConnected(element) {
    this.beforeMorphAttribute(element)
    // If there are no bullet with .active class, call showCurrentChunk()
    if (!this.bulletTargets.find(bullet => bullet.classList.contains('active'))) {
      this.showCurrentChunk();
    }
  }

  showCurrentChunk() {

    // Scroll to the top
    document.getElementById('module-content').scrollTop = 0
    // Scroll page to the top
    window.scrollTo(0, 0);

    if (this.currentChunkValue > this.lastChunkValue) {
      this.lastChunkValue = this.currentChunkValue;
    }

    this.chunkTargets.forEach((chunk, index) => {
      if (index === this.currentChunkValue) {
        chunk.classList.add('active');
        chunk.parentElement.style.height = `${chunk.offsetHeight+52}px`;
      } else {
        chunk.classList.remove('active');
      }
    });

    this.bulletTargets.forEach((bullet, index) => {
      if (index === this.currentChunkValue) {
        bullet.classList.add('active');
      } else {
        bullet.classList.remove('active');
      }
    });
  }

}
